var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContLogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 27,
    viewBox: "0 0 93 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4646 0H28.7082V26.1998H24.4646V0Z",
    fill: "#17313B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4687 17.8971C43.4687 21.9562 40.1476 22.3252 39.0406 22.3252C36.4575 22.3252 36.0885 19.9267 36.0885 18.6351V8.4873H31.8448V18.4506C31.8448 20.8492 32.5829 23.0632 34.0589 24.3548C35.3505 25.6463 37.011 26.1998 39.0406 26.1998C40.5166 26.1998 42.3617 25.8308 43.4687 24.7238V26.1998H47.7123V8.4873H43.4687V17.8971Z",
    fill: "#17313B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0151 2.02954H51.7715V8.48724H48.6349V12.5464H51.7715V26.1998H56.0151V12.5464H59.1517V8.48724H56.0151V2.02954Z",
    fill: "#17313B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4361 20.8491C71.5136 21.5871 70.222 22.1406 68.9305 22.1406C65.9784 22.1406 63.9488 19.9265 63.9488 16.9744C63.9488 14.0223 65.9784 11.9928 68.9305 11.9928C70.222 11.9928 71.5136 12.3618 72.4361 13.2843L72.9896 13.8378L75.9417 11.0703L75.2037 10.5167C73.5431 9.04069 71.3291 8.11816 68.9305 8.11816C63.7643 8.11816 59.8897 11.9928 59.8897 17.1589C59.8897 22.3251 63.7643 26.1997 68.9305 26.1997C71.3291 26.1997 73.5431 25.2772 75.2037 23.8011L75.9417 23.2476L72.9896 20.2955L72.4361 20.8491Z",
    fill: "#17313B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8866 9.96331C89.595 8.67177 88.3035 8.11825 86.2739 8.11825C84.7979 8.11825 83.3219 8.48726 82.2148 9.59429V0H77.9712V26.1998H82.2148V16.421C82.2148 12.3619 84.9824 11.9929 86.0894 11.9929C88.6725 11.9929 88.488 14.3914 88.488 15.683V26.0153H92.7316V15.8675C92.7316 13.4689 92.1781 11.2548 90.8866 9.96331Z",
    fill: "#17313B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.746 20.111C70.3764 20.111 71.6981 18.7893 71.6981 17.1589C71.6981 15.5285 70.3764 14.2068 68.746 14.2068C67.1156 14.2068 65.7939 15.5285 65.7939 17.1589C65.7939 18.7893 67.1156 20.111 68.746 20.111Z",
    fill: "#EF4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5604 19.742C17.0844 21.2181 14.8703 22.1406 12.4717 22.1406C7.85911 22.1406 4.53801 18.4505 4.53801 13.4688C4.53801 8.48718 7.85911 4.79707 12.6563 4.79707C14.8703 4.79707 17.0844 5.7196 18.7449 7.38015L19.2985 7.93366L22.066 5.16608L21.5125 4.61256C19.1139 2.21399 15.9774 0.92245 12.6563 0.92245C5.64504 0.737944 0.478882 6.27311 0.478882 13.4688C0.478882 20.6646 5.64504 26.1997 12.4717 26.1997C15.7928 26.1997 19.114 24.9082 21.328 22.5096L21.8815 21.9561L19.1139 19.1885L18.5604 19.742Z",
    fill: "#17313B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContLogo01);
export default __webpack_public_path__ + "static/media/cont_logo01.f8d3c296d11d1bf9fe09d620cc39b1b6.svg";
export { ForwardRef as ReactComponent };